interface WordsForResult {
  forOne: string
  forTwo: string
  forFive: string
}
/* Чтобы воспользоваться функцией передайте объект со словами,
которые можно представить так:
forOne - 1 участник (поле forOne в передаваемом объекте "участник")
forTwo - 2 участника (поле forTwo в передаваемом объекте "участника")
forFive - 5 участников (поле forFive в передаваемом объекте - "участников")
*/

export const getTextForDifferentCount = (count: number, word: WordsForResult): string => {
  if (typeof count !== 'number') {
    return ''
  }
  const countToString = count.toString()
  if (count > 9 && +countToString.slice(-2) < 20) {
    return count + ' ' + word.forFive
  } else if (countToString.endsWith('1')) {
    return count + ' ' + word.forOne
  } else if (countToString.endsWith('2') || countToString.endsWith('3') || countToString.endsWith('4')) {
    return count + ' ' + word.forTwo
  }
  return count + ' ' + word.forFive
}
